import React from 'react';

import { useAppSelector } from '@pkg/hooks';

import { useFetchOrders } from '@app/pages/ProfilePage/hooks';

import { StatsItem } from './StatsItem';

import { Wrapper } from './styles';

export const Stats = () => {
    const { data } = useFetchOrders();
    const { incomingOffers, listings } = data || {};
    const marketplaceV1Enabled = useAppSelector((state) => state.featureFlags.features.marketplaceV1Enabled);
    if (!marketplaceV1Enabled) return null;

    return (
        <Wrapper>
            {/* TODO: Confirm if we want to share different currency totals */}
            {/*<StatsItem label="Net worth" value={32475.15} currency="usd" subLabel="24h" diffPercent={25} />*/}

            {/* TODO: Add back once we get totals */}
            {/*<StatsItem label="Collectibles" value={14531} />*/}

            <StatsItem label="Listed" value={listings?.length || 0} />
            <StatsItem
                label="Offers"
                value={incomingOffers?.length || 0}
                // TODO: ask BE about these stats
                // subLabel="24h"
                // diffNumber={3}
                // diffDirection="down"
            />
        </Wrapper>
    );
};
